import { useContext, useMemo } from 'react';
import { useStore } from 'zustand';

import { ApplicationContext } from '~/shared/context/context';

import type { JobItemDetails } from '../api/use-job-item-details';
import { patchMissingTranslations } from '../api/use-job-item-details';
import { useDraftVersionStore } from './DraftVersionStoreProvider';

export const useDraftJobItemDetails = ({
    itemId,
}: {
    readonly itemId: string;
}): {
    readonly draftData: JobItemDetails | undefined;
    readonly hasDraft: boolean;
} => {
    const {
        applicationState: { customization },
    } = useContext(ApplicationContext);
    const availableLanguages = customization.get('commonConfiguration').get('languages').unwrapOr([]);
    const store = useDraftVersionStore();

    const draft = useStore(store, (state) => state.drafts.get(itemId));

    const hasDraft = draft !== undefined;

    return useMemo(() => {
        if (draft !== undefined) {
            return {
                draftData: patchMissingTranslations(draft, availableLanguages),
                hasDraft,
            };
        }

        return {
            draftData: undefined,
            hasDraft: false,
        };
    }, [draft, availableLanguages, hasDraft]);
};
